import VenueFilterInput from './VenueFilterInput';

export const getVenueFilterOperators = (translate) => {
  const t = translate || ((k, opts) => opts?._ || k);
  return [
    {
      label: t('filters.equals', { _: 'Equals' }),
      value: 'equals',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const id = String(filterItem.value);
        return (params) => String(params.row?.venue ?? params.value ?? '') === id;
      },
      InputComponent: VenueFilterInput,
    },
  ];
};

const venueFilterOperators = getVenueFilterOperators((k, opts) => opts?._ || k);

export default venueFilterOperators;
